import { db } from "../../../service/API";
const ft = require("../Tools/FileTools");

export class TemplateConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  getTemplate() {
    return new Promise((resolve, reject) => {
      db.get("/TemplateConnector/listSharedTemplate/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get shared template failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("get shared template error " + err.message);
        });
    });
  }

  getDuration(path) {
    return new Promise((resolve, reject) => {
      db.post("/TemplateConnector/getDuration/", {
        sid: this.socId,
        path: path,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              return resolve(response.data[0].duration);
            } else {
              return reject("get duration not found :" + path);
            }
          } else {
            return reject("get duration failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get duration failed with error : " + err.message);
        });
    });
  }

  deleteTemplate(id) {
    return new Promise((resolve, reject) => {
      db.delete("/TemplateConnector/deleteTemplate/", {
        sid: this.socId,
        id: id,
      })
        .then((response) => {
          if (response.status == 204) {
            ft.deletethumb(id, true);
            return resolve();
          } else {
            return reject("delete template failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete template error " + err.message);
        });
    });
  }

  deleteTemplateWithPath(path) {
    return new Promise((resolve, reject) => {
      db.delete("/TemplateConnector/deleteTemplateWithPath/", {
        sid: this.socId,
        path: path,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else if (response.status == 200) {
            ft.deletethumb(response.data.pid, true);
            return resolve();
          } else {
            return reject("delete template by path failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete template by path error " + err.message);
        });
    });
  }
}
